import { Tooltip } from '@spotted-zebra-uk/ui-components';
import { ProjectTableItemFragment } from 'generated/graphql';
import { emptyDisplayValue } from 'constants/common';
import { STAGE_CATEGORY_LABELS } from '../../Projects.constants';
import StageTypeChip from '../StageTypeChip/StageTypeChip';
import {
  getStageCategoryCounts,
  getStagesAriaLabel,
  getStagesTotal,
} from './ProjectStagesCell.helpers';
import styles from './ProjectStagesCell.module.scss';

export const PROJECT_STAGES_CELL_DATA_TEST_ID = 'project-stages-cell';

const ProjectStagesCell = ({
  project,
}: {
  project: ProjectTableItemFragment;
}) => {
  const stageCounts = getStageCategoryCounts(project);
  const totalStages = getStagesTotal(stageCounts);

  if (!totalStages) {
    return (
      <span data-testid={`${PROJECT_STAGES_CELL_DATA_TEST_ID}-empty`}>
        {emptyDisplayValue}
      </span>
    );
  }

  return (
    // Tooltip overwrites its child's data-testid with its own, so the stable
    // handle for this cell lives on the wrapper.
    <span data-testid={PROJECT_STAGES_CELL_DATA_TEST_ID}>
      <Tooltip
        ariaLabel={getStagesAriaLabel(stageCounts)}
        globalCloseEvents={{ escape: true }}
        render={() => (
          <div className={styles.tooltip}>
            {stageCounts.map(stageCount => (
              <div className={styles.tooltipRow} key={stageCount.category}>
                <span className={styles.tooltipStage}>
                  <StageTypeChip category={stageCount.category} isSmall />
                  {STAGE_CATEGORY_LABELS[stageCount.category]}
                </span>
                <span className={styles.tooltipCount}>{stageCount.count}</span>
              </div>
            ))}
          </div>
        )}
      >
        <span className={styles.cell} tabIndex={0}>
          <span className={styles.total}>{totalStages}</span>
          <span className={styles.chips}>
            {stageCounts.map(stageCount => (
              <StageTypeChip
                category={stageCount.category}
                key={stageCount.category}
              />
            ))}
          </span>
        </span>
      </Tooltip>
    </span>
  );
};

export default ProjectStagesCell;
